export const browserStorageKey = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  BACKUP_URL: 'backupUrl',
  LAST_KNOWN_LANGUAGE: 'lastKnownLanguage',
  ALPHA_CATALOGUE_VERSION: 'alphaCatalogueVersion',
  CURRENT_VERSION: 'currentVersion',
  PERMISSIONS: 'userPermissions',
  SALES_ACTIVITY_PANEL_OPEN: 'salesActivityPanelOpen',
  LAST_PROMO_FEATURE_SEEN: 'lastPromoFeatureSeen',

  // IAM TOKENS INIT ---------------------------
  PENDING_ACCESS_TOKEN: 'pending_access_token',
  PENDING_REFRESH_TOKEN: 'pending_refresh_token',

  // DO NOT TOUCH: DEV SETTINGS ---------------------------
  CI_MODE: 'cimode',
  MOCK_FLAGS_KEY: 'featureFlagMock',
  DEV_SETTINGS_SIDEBAR_STATE: 'devSettingsSidebarState',
  DISABLE_MANDATORY_FIELDS_VALIDATION: 'disableMandatoryFieldsValidation',
  PERFORMANCE_TRACKING_ENABLED: 'performanceTrackingEnabled',
};
